import React from "react";
import { Tag } from "antd";
import { AUDBILITY_STATUS_CONFIG, STATUS_STYLES } from "../../constants";
import classes from "./AudbilityStatusTag.module.scss";

const AudbilityStatusTag = ({
  statusKey,
  label,
  config = AUDBILITY_STATUS_CONFIG,
}) => (
  <Tag
    className={classes.StatusTag}
    style={config[statusKey]?.style || STATUS_STYLES.gray}
  >
    {label}
  </Tag>
);

export default AudbilityStatusTag;
